export const CART_COOKIE_NAME = 'cartId';
export const CART_QUERY_KEY = 'cart';
